export enum UAEPassControlAction {
  Login = 'login',
}

const getUAEPassActionOptions = () => [
  {
    const: UAEPassControlAction.Login,
    title: 'Login',
    icon: 'SvgAuthByUnifyapps',
    groupId: 1,
  },
];

export const getControlUAEPassSchema = () => {
  const actionOptions = getUAEPassActionOptions();
  return {
    type: 'object',
    properties: {
      operation: {
        type: 'string',
        title: 'Operation',
        default: UAEPassControlAction.Login,
        oneOf: actionOptions,
      },
    },
  };
};

export const getControlUAEPassUISchema = () => {
  const actionOptions = getUAEPassActionOptions();

  return {
    operation: {
      'ui:title': 'Operation',
      'ui:widget': 'GroupedSelectWidget',
      'ui:options': {
        'ua:enumIcons': actionOptions.map((option) => option.icon),
        'ua:enumGroup': actionOptions.map((option) => option.groupId),
      },
    },
  };
};
